(function ($, Drupal, drupalSettings) {
        
  updateClassAndAttr();

       
    function updateClassAndAttr() {

        if (drupalSettings.noahs_page_builder?.classes && Object.keys(drupalSettings.noahs_page_builder.classes).length > 0) {
            var Noahsclasses = drupalSettings.noahs_page_builder.classes;
      
            $.each(Noahsclasses, function(index, values) {
                $.each(values, function(key, value) {
            
                    $.each(value, function(selector, $class) {
                        $(selector).addClass($class);
                    });
                });
            });
        }

        if (drupalSettings.noahs_page_builder?.attributes && Object.keys(drupalSettings.noahs_page_builder.attributes).length > 0) {
            var NoahsAttributes = drupalSettings.noahs_page_builder.attributes;
            $.each(NoahsAttributes, function(index, values) {
                if (values.length) {
                    $.each(values, function(key, value) {
                        $.each(value, function(selector, attributes) {
                            $.each(attributes, function(i, $attribute) {
                                $(selector).attr(i, $attribute);
                            });
                        });
                    });
                }
            });
        }
    }
  })(jQuery, Drupal, drupalSettings);

